import React, { FC } from 'react';
import { IconProps } from '../../@types/ui';

const FacebookIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={`w-${width} h-${height}`}
      fill="currentcolor"
      role="presentation"
    >
      <path
        stroke="currentColor"
        d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
      ></path>
    </svg>
  );
};
const ConnectionIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M48 0H0V48H48V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M13.5 39.3707C16.3908 41.644 20.0371 43 24 43C27.9629 43 31.6092 41.644 34.5 39.3707"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        d="M19 9.74719C12.0513 11.8823 7 18.3513 7 26C7 27.9248 7.31989 29.7749 7.9094 31.5"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        d="M29 9.74719C35.9487 11.8823 41 18.3513 41 26C41 27.9248 40.6801 29.7749 40.0906 31.5"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        d="M43 36C43 37.3416 42.4716 38.5597 41.6117 39.4577C40.7015 40.4082 39.4199 41 38 41C35.2386 41 33 38.7614 33 36C33 33.9899 34.1861 32.2569 35.8967 31.4626C36.536 31.1657 37.2487 31 38 31C40.7614 31 43 33.2386 43 36Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 36C15 37.3416 14.4716 38.5597 13.6117 39.4577C12.7015 40.4082 11.4199 41 10 41C7.23858 41 5 38.7614 5 36C5 33.9899 6.18614 32.2569 7.89667 31.4626C8.53604 31.1657 9.24867 31 10 31C12.7614 31 15 33.2386 15 36Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29 9C29 10.3416 28.4716 11.5597 27.6117 12.4577C26.7015 13.4082 25.4199 14 24 14C21.2386 14 19 11.7614 19 9C19 6.98991 20.1861 5.25686 21.8967 4.4626C22.536 4.16572 23.2487 4 24 4C26.7614 4 29 6.23858 29 9Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MobilePhoneIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6"
        y="3"
        width="12"
        height="19"
        rx="1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0161 18.0161L12 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const EmailIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="currentColor"
      className={`w-${width} h-${height}`}
    >
      <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
      <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
    </svg>
  );
};

const FriendsIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="g1" transform="translate(-21.547855,-31.548921)">
        <path
          fill="currentcolor"
          d="m 24.806948,51.84929 c -0.79239,-0.321904 -1.123584,-1.32866 -0.741648,-2.254446 0.653754,-1.584647 1.674945,-6.912015 1.351089,-7.048399 -0.05513,-0.0232 -0.669343,0.06828 -1.364931,0.20335 -2.065248,0.400989 -2.588685,0.166239 -2.49288,-1.118001 0.04502,-0.603352 0.167845,-0.69296 2.641669,-1.927099 0.572123,-0.285421 0.809064,-0.404464 1.580884,-0.794275 0.194356,-0.09816 0.453806,-0.228895 0.576559,-0.29052 1.748533,-0.87783 2.325347,-1.32144 3.038212,-2.336589 0.660951,-0.941222 1.537055,-3.068567 1.537055,-3.732256 0,-1.17965 1.721882,-1.38499 2.136352,-0.254769 0.385452,1.051093 -0.760231,5.033921 -2.056551,7.149356 -0.383753,0.626242 -0.383753,0.626242 -0.309305,1.766441 0.04096,0.62711 0.110071,1.807712 0.153607,2.62356 0.115573,2.165713 0.216811,3.937609 0.309029,5.408628 0.115376,1.84049 -0.06961,2.388305 -0.891633,2.640504 -0.961715,0.295055 -1.496299,-0.351472 -1.64424,-1.98855 -0.05056,-0.559438 -0.122239,-1.22442 -0.159298,-1.477735 -0.03707,-0.253316 -0.06739,-0.647085 -0.06739,-0.875042 0,-0.594264 -0.186455,-0.511494 -0.430962,0.191312 -0.216354,0.621884 -1.15058,2.721467 -1.363603,3.064567 -0.07685,0.123745 -0.139692,0.262345 -0.139692,0.308 0,0.48981 -1.087832,0.97535 -1.662334,0.741963 z m 8.777227,0.0014 c -0.771609,-0.318683 -0.908206,-0.768658 -0.79676,-2.62465 0.101631,-1.692552 0.20147,-3.460055 0.304485,-5.390446 0.04353,-0.815847 0.112451,-1.993584 0.153142,-2.61719 0.07398,-1.133831 0.07398,-1.133831 -0.334174,-1.825581 -0.543864,-0.921749 -0.535467,-0.850742 -0.19683,-1.664704 0.163829,-0.393787 0.441071,-1.221267 0.616096,-1.838844 0.273677,-0.965675 0.429817,-1.344618 0.429817,-1.043141 0,0.724977 1.596448,2.568634 2.789794,3.221793 0.83107,0.454872 1.433106,0.766628 1.480449,0.766628 0.01725,0 0.277073,0.129447 0.577369,0.287661 0.300296,0.158216 0.813814,0.42079 1.141148,0.583503 0.327336,0.162714 0.779283,0.391414 1.004328,0.508229 0.225043,0.116813 0.580992,0.295657 0.790994,0.397428 0.888453,0.43056 1.150451,1.390361 0.562418,2.060351 -0.317312,0.361538 -0.688653,0.373762 -2.245766,0.07392 -1.630285,-0.313927 -1.519993,-0.450974 -1.218262,1.513761 0.06085,0.396269 0.143148,0.941552 0.18287,1.211741 0.167443,1.138936 0.727909,3.322646 1.058365,4.123643 0.911818,2.210177 -1.566759,3.262444 -2.606635,1.106634 -0.639667,-1.326123 -0.875794,-1.858875 -1.174726,-2.650435 -0.408307,-1.081186 -0.522701,-1.140575 -0.576143,-0.299112 -0.234207,3.6877 -0.676587,4.621402 -1.941979,4.098794 z M 26.391209,37.19262 c -2.240224,-0.683229 -1.872081,-4.969576 0.426825,-4.969576 2.270457,0 2.657154,4.529187 0.423492,4.960145 -0.158774,0.03064 -0.338897,0.06853 -0.400272,0.08417 -0.06138,0.01567 -0.263896,-0.01797 -0.450045,-0.07475 z m 10.436857,0.01513 c -2.278148,-0.391495 -2.112888,-4.745492 0.18857,-4.968083 2.368369,-0.229065 2.83426,4.392861 0.500239,4.962666 -0.163668,0.03996 -0.473633,0.04239 -0.688809,0.0055 z"
        />
      </g>
    </svg>
  );
};

const SmileyIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentcolor"
        fillRule="evenodd"
        d="M8,0 C12.4183,0 16,3.58172 16,8 C16,12.4183 12.4183,16 8,16 C3.58172,16 0,12.4183 0,8 C0,3.58172 3.58172,0 8,0 Z M8,2 C4.68629,2 2,4.68629 2,8 C2,11.3137 4.68629,14 8,14 C11.3137,14 14,11.3137 14,8 C14,4.68629 11.3137,2 8,2 Z M11,9 C11,10.6569 9.65685,12 8,12 C6.40232321,12 5.09633941,10.7511226 5.00509271,9.17627735 L5,9 L11,9 Z M6,5 C6.55228,5 7,5.44772 7,6 C7,6.55228 6.55228,7 6,7 C5.44772,7 5,6.55228 5,6 C5,5.44772 5.44772,5 6,5 Z M10,5 C10.5523,5 11,5.44772 11,6 C11,6.55228 10.5523,7 10,7 C9.44771,7 9,6.55228 9,6 C9,5.44772 9.44771,5 10,5 Z"
      />
    </svg>
  );
};

const ProfileIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      fill="currentcolor"
      role="presentation"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
      ></path>
    </svg>
  );
};

const InstaIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="16.5" cy="7.5" r="1.5" fill="currentColor" />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};

const LinkedInIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>linkedin</title>
      <path d="M28.778 1.004h-25.56c-0.008-0-0.017-0-0.027-0-1.199 0-2.172 0.964-2.186 2.159v25.672c0.014 1.196 0.987 2.161 2.186 2.161 0.010 0 0.019-0 0.029-0h25.555c0.008 0 0.018 0 0.028 0 1.2 0 2.175-0.963 2.194-2.159l0-0.002v-25.67c-0.019-1.197-0.994-2.161-2.195-2.161-0.010 0-0.019 0-0.029 0h0.001zM9.9 26.562h-4.454v-14.311h4.454zM7.674 10.293c-1.425 0-2.579-1.155-2.579-2.579s1.155-2.579 2.579-2.579c1.424 0 2.579 1.154 2.579 2.578v0c0 0.001 0 0.002 0 0.004 0 1.423-1.154 2.577-2.577 2.577-0.001 0-0.002 0-0.003 0h0zM26.556 26.562h-4.441v-6.959c0-1.66-0.034-3.795-2.314-3.795-2.316 0-2.669 1.806-2.669 3.673v7.082h-4.441v-14.311h4.266v1.951h0.058c0.828-1.395 2.326-2.315 4.039-2.315 0.061 0 0.121 0.001 0.181 0.003l-0.009-0c4.5 0 5.332 2.962 5.332 6.817v7.855z"></path>
    </svg>
  );
};

const SoundcloudIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      id="sc"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-${width} h-${height}`}
      fill="currentColor"
      viewBox="0 0 300 166"
    >
      <path d="M144,0c5.33,0,10.67,0,16,0,.94.28,1.87.69,2.83.82,35.54,4.69,63.45,30.84,70.43,66.03.54,2.7.99,5.41,1.52,8.37,2.19-.63,3.91-1.14,5.65-1.62,23.72-6.5,49.03,6.76,57.05,29.91.96,2.78,1.68,5.66,2.51,8.49v14c-.28.57-.72,1.11-.83,1.72-2.62,14.55-10.89,25.18-23.48,32.25-5.09,2.86-11.1,4.07-16.69,6.03h-128c-.7-2.27-2.01-4.55-2.02-6.82-.12-48.93-.09-97.86-.09-146.8,0-1.16-.01-2.33.08-3.49.3-3.94,2.09-6.51,6.3-7.11C138.21,1.36,141.09.6,144,0Z" />
      <path d="M102,166c-4.44-2-5.98-5.31-5.96-10.26.16-44.98.12-89.96.06-134.94,0-5.68,1.29-10.58,6.5-13.66,5.71-3.37,11.67-1.09,13.36,5.29.68,2.53.88,5.26.89,7.9.05,45.15-.03,90.29.13,135.44.02,4.96-1.54,8.25-5.99,10.24h-9Z" />
      <path d="M71,166c-5.26-1.83-7.12-5.37-7.07-11.04.25-27.15.1-54.3.13-81.45,0-5.89,2.62-9.97,7.1-11.4,6.93-2.22,13.44,2.53,13.61,10.26.21,9.16.05,18.32.05,27.48,0,18.32-.16,36.65.1,54.97.08,5.56-1.6,9.32-6.92,11.19h-7Z" />
      <path d="M0,93c3.83-6.65,8.61-9.04,14.09-6.76,4.47,1.86,6.47,5.5,6.48,10.27.01,13.12.09,26.24-.03,39.36-.06,6.91-1.69,9.14-6.88,10.51-5.16,1.36-9.32-.42-12.67-5.41-.25-.38-.65-.65-.98-.98,0-15.67,0-31.33,0-47Z" />
      <path d="M32.08,105.93c0-14.99-.02-29.98.01-44.97.02-7.07,4.03-11.72,10.07-11.82,6.24-.11,10.53,4.62,10.55,11.93.05,30.15.04,60.3,0,90.45,0,7.03-3.42,10.15-10.65,10.02-6.97-.12-9.96-3.13-9.97-10.13-.02-15.16,0-30.32,0-45.47Z" />
    </svg>
  );
};
const TwXIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      id="twx"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 435.44 394.27"
      className={`w-${width} h-${height}`}
    >
      <g id="Layer_1">
        <path d="M183.59,257.45c-10.33,11.15-19.89,21.56-29.55,31.87-18.57,19.81-37.21,39.56-55.8,59.35-13,13.85-26.02,27.68-38.9,41.64-2.6,2.82-5.38,3.94-9.2,3.89-14.83-.2-29.66-.11-44.5-.17-1.41,0-2.83-.23-4.78-.4.71-1.45.94-2.44,1.54-3.09,40.33-43.03,80.69-86.02,121.03-129.03,10.94-11.66,21.71-23.47,32.75-35.03,2.6-2.72,2.1-4.58.16-7.26-16.31-22.54-32.55-45.12-48.73-67.75C75.94,107.19,44.32,62.85,12.67,18.53,8.65,12.89,4.63,7.23,0,.73,2.32.45,3.69.14,5.05.14,53.55.1,102.05.11,150.56,0c3.52,0,5.86,1.09,7.93,4,16.1,22.66,32.37,45.21,48.53,67.83,12.19,17.07,24.32,34.19,36.43,51.32,3.63,5.13,3.77,5.22,7.88.83,31.89-34.04,63.77-68.09,95.63-102.15,5.8-6.2,11.37-12.62,17.3-18.69,1.47-1.5,3.92-2.84,5.94-2.87,16.5-.25,33-.18,49.5-.15.9,0,1.8.43,3.64.89-1.46,1.76-2.39,2.99-3.44,4.12-31.15,33.37-62.3,66.73-93.47,100.08-17.18,18.38-34.35,36.76-51.63,55.03-2.11,2.23-2.36,3.54-.44,6.21,25.13,35.05,50.09,70.23,75.1,105.37,22.11,31.06,44.25,62.11,66.37,93.17,5.5,7.73,10.98,15.48,16.43,23.25,1.02,1.46,1.86,3.05,3.18,5.25-1.96.27-3.17.59-4.39.59-47.33.04-94.67-.05-142,.2-5.47.03-8.78-1.65-11.91-6.06-28.31-39.95-56.82-79.76-85.29-119.6-2.49-3.48-5.1-6.88-8.27-11.15ZM80.34,41.97c.69,1.43,1.04,2.5,1.66,3.37,8,11.27,16.01,22.53,24.08,33.76,27.22,37.85,54.46,75.68,81.69,113.53,18.96,26.36,37.9,52.73,56.86,79.09,18.57,25.82,37.09,51.68,55.84,77.37,1.28,1.76,4.28,3.15,6.51,3.19,14.16.29,28.33.15,42.49.16,2.06,0,4.13,0,7.15,0-1.34-2.2-2.02-3.48-2.85-4.64-10.06-14.09-20.16-28.16-30.23-42.26-28.66-40.12-57.27-80.26-85.96-120.35-14.63-20.44-29.45-40.76-44.1-61.19-18.84-26.25-37.63-52.52-56.35-78.86-1.96-2.75-4.17-3.81-7.52-3.77-15.16.15-30.33.07-45.5.1-1.09,0-2.18.28-3.77.49Z" />
      </g>
    </svg>
  );
};
const TikTokIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      fill="currentColor"
      className={`w-${width} h-${height}`}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>
    </svg>
  );
};
const YouTubeIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={`w-${width} h-${height}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
      ></path>
    </svg>
  );
};

const WhatsAppIcon: FC<IconProps> = ({ width, height }) => {
  return (
    <svg
      className={`w-${width} h-${height}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z"
        fill="currentColor"
      />
    </svg>
  );
};
export {
  ConnectionIcon,
  FacebookIcon,
  InstaIcon,
  LinkedInIcon,
  MobilePhoneIcon,
  EmailIcon,
  FriendsIcon,
  ProfileIcon,
  SmileyIcon,
  SoundcloudIcon,
  TikTokIcon,
  TwXIcon,
  YouTubeIcon,
  WhatsAppIcon,
};
